import { CircleDashed, Phone, Users } from "lucide-react";
import { LINKS } from "@/lib/site";
import { Reveal, SectionLabel } from "@/components/Reveal";
import PhoneMockup from "@/components/PhoneMockup";

const CARDS = [
  {
    icon: Users,
    title: "WhatsApp Community",
    text: "Join the JGW community and receive important updates directly through our WhatsApp groups.",
    cta: "View Groups",
    href: LINKS.community,
    testId: "community-card-view-groups-button",
  },
  {
    icon: CircleDashed,
    title: "WhatsApp Status",
    text: "Subscribe to the JGW status and view timely updates throughout the day.",
    cta: "Subscribe to Status",
    href: LINKS.status,
    phone: LINKS.statusPhoneDisplay,
    phoneHref: LINKS.statusPhoneHref,
    testId: "status-card-subscribe-button",
  },
];

const JoinJgw = () => (
  <section
    id="join"
    data-testid="join-section"
    className="border-t border-white/5 bg-charcoal py-14 lg:py-16"
  >
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 lg:grid-cols-[1.15fr_1fr] lg:px-10">
      <div>
        <Reveal>
          <SectionLabel>Join JGW</SectionLabel>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white md:text-4xl">
            Choose How You Want to Stay Updated
          </h2>
        </Reveal>

        <div className="mt-8 grid gap-5">
          {CARDS.map((card, i) => (
            <Reveal key={card.title} delay={i * 0.07}>
              <article
                data-testid={`join-card-${card.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="group flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.04] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-whatsapp/40 hover:bg-white/[0.06] sm:p-7"
              >
                <div className="flex items-start gap-5">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-whatsapp/12 text-whatsapp">
                    <card.icon size={22} strokeWidth={2} />
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="font-display text-xl font-bold tracking-tight text-white">
                      {card.title}
                    </h3>
                    <p className="mt-2 text-[15px] leading-relaxed text-silver">{card.text}</p>
                    {card.phone && (
                      <a
                        href={card.phoneHref}
                        data-testid="status-card-phone-link"
                        className="mt-3.5 inline-flex items-center gap-2.5 rounded-lg border border-white/10 bg-black/40 px-4 py-2.5 transition-colors duration-200 hover:border-whatsapp/40"
                      >
                        <Phone size={15} className="text-whatsapp" strokeWidth={2} />
                        <span className="text-sm font-bold tracking-wide text-white">{card.phone}</span>
                      </a>
                    )}
                  </div>
                </div>
                <a
                  href={card.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={card.testId}
                  className="mt-5 inline-flex w-fit items-center justify-center gap-2 rounded-xl bg-whatsapp px-6 py-3.5 text-sm font-bold text-white transition-colors duration-200 hover:bg-whatsapp-dark"
                >
                  <card.icon size={17} strokeWidth={2.2} />
                  {card.cta}
                </a>
              </article>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal className="justify-self-center">
        <PhoneMockup />
      </Reveal>
    </div>
  </section>
);

export default JoinJgw;
